import axios from "axios";
import debounce from "debounce-promise";
import type { PlayerUser } from "Models";
import { config } from "@/config/env";
import { clubhouseApiHeadersV1, clubhouseApiHeadersV2 } from "../api/apiHelper";

export const userSearch = async (query: string) => {
  const { data } = await axios.get(
    `${config.apiBaseUrl}/api/players/search?names=${query}`,
    clubhouseApiHeadersV2(),
  );
  return data;
};

export const playerUsersByLockerId = async (
  lockerUserGuids: string[] | undefined,
) => {
  const response = await axios.get(
    `${config.apiBaseUrl}/api/user-search/GetByGuid?guid=${lockerUserGuids?.join(",")}`,
    clubhouseApiHeadersV1(),
  );
  return response.data;
};

export const isPlayerInArray = (player: PlayerUser, array: PlayerUser[]) => {
  return array?.some((item) => player.username === item.username)
    ? true
    : false;
};

const getAsyncOptions = (inputValue: string) => {
  return new Promise<PlayerUser[]>((resolve) => {
    const options = userSearch(inputValue);
    resolve(options);
  });
};

export const getReservationPlayerUsers = async (
  lockerUserGuids: string[] | undefined,
) => {
  if (!lockerUserGuids) {
    return new Promise<PlayerUser[]>((resolve) => resolve([]));
  }
  return playerUsersByLockerId(lockerUserGuids);
};

const loadOptions = (inputValue: string) => {
  return getAsyncOptions(inputValue);
};

export const debouncedLoadOptions = debounce(loadOptions, 1000);
